import { Route } from '@angular/router';

export const liveLessonModeratorFeatureShellRoutes: Route[] = [
    /* { path: '', pathMatch: 'full', component: InsertYourComponentHere } */
];
